import React from "react";
import { useRoutes } from "react-router-dom";
import { ProtectedRoutesObject } from "./Routes";

const ProtectedRoutes = () => {
  let RenderProtectedRoutes = useRoutes(ProtectedRoutesObject);
  return <React.Fragment>{RenderProtectedRoutes}</React.Fragment>;
};

export default ProtectedRoutes;
